import { Injectable } from '@angular/core';
import { HowlRx } from '@core/services/howl-observable';
import { GameAudio } from '@games/core/controller/component-blocks/audio';
import { SoundLib } from '@games/core/sound/sound-lib';

@Injectable({
  providedIn: 'root',
})
export class TextsQuizService {

  // private vhsClick: HowlRx;

  // private _gameAudio: GameAudio;

  constructor() {
  }

  // setGameAudio(gameAudio: GameAudio): void {
  //   this._gameAudio = gameAudio;
  //   // this._gameAudio.prepareSound('speed-reading/vhs-click.mp3').subscribe((res) => {
  //   //   this.vhsClick = res;
  //   // });
  // }

  playVhsClick(gameAudio: GameAudio) {
    if (!gameAudio) {
      console.warn('gameAudio is required for vhsClick.');
      return;
    }
    gameAudio.play(SoundLib.VhsClick);  }
}
